import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'gatsby';

const BlogButton: React.FC = () => {
  return (
    <>
      <Link to="/blog/" id="blog-pages">
        <Button>Blog</Button>
      </Link>
    </>
  );
};

const Button = styled.div`
  border-style: solid;
  border-width: 1px;
  border-color: white;
  padding: 0.7rem;
  width: 50px;
  text-align: center;
`;

export default BlogButton;
